function u() {
  return new Error(
    "Do not call factory directly, pass it to invoke function instead"
  );
}
function l() {
  return new Error("Function passed to invoke is not created by createFactory");
}
function s() {
  return new Error(
    "createFactory does not support functions with more than 1 argument"
  );
}
let t = 0, c = 0, o = 0;
function f() {
  o += 1;
}
function y(e, a) {
  t += 1, c += 1;
  const r = e(a);
  t -= 1;
  const n = o === 0;
  let i = !1;
  if (t === 0 && (i = o !== c, o = 0, c = 0), n)
    throw l();
  if (i)
    throw u();
  return r;
}
function h(e) {
  if (e.length > 1)
    throw s();
  return (r) => {
    if (t === 0)
      throw u();
    const n = e(r);
    return f(), n;
  };
}
export {
  h as createFactory,
  y as invoke
};
